import React, { FC, ReactNode } from 'react'
import { useRouter } from 'next/router'

import Button from '../../parts/button/button'

import { cutHashFromURL } from 'utils/getURLData'
import { popupName } from 'constants/auth/auth-data'

import style from './banner-auth-warning.module.scss'

interface IBannerAuthWarning {
  children?: ReactNode | string
}

const BannerAuthWarning: FC<IBannerAuthWarning> = ({
  children = (
    <>
      Уважаемый коллега! Для полного доступа к материалам вам необходимо{' '}
      <span>войти&nbsp;на&nbsp;Medpoint</span>
    </>
  ),
}: IBannerAuthWarning) => {
  const router = useRouter()
  const path = cutHashFromURL(router.asPath)

  const handleClick = () => {
    router.push(`${path}#${popupName.registration}`)
  }

  return (
    <div className={style.wrapper}>
      <div className={style.txt}>{children}</div>
      <Button modificator={style.btn} onClick={handleClick}>
        Войти
      </Button>
    </div>
  )
}

export default BannerAuthWarning
